import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { useIsCroatian } from "@/helpers/translation/useIsCroatian.ts";
import { AccommodationType, AccommodationTypeTranslation } from "@/helpers/types/types.ts";
import { getLocale } from "@/stores/ApolloClient/helpers/getLocale.ts";
import { useTranslation } from "react-i18next";

export interface GetAccTypeTranslatedInfoResponse extends Pick<AccommodationTypeTranslation, "name"> {
  translation?: AccommodationTypeTranslation;
  getTranslatedAccommodationTypesData: (rg: AccommodationType) => {
    translation?: AccommodationTypeTranslation;
    name?: string;
  };
}
/**
 * Retrieves translated information for a AccommodationType (AccType).
 * Default App language is "hr"
 *     - if it's hr return directly the entity values
 *     - if it's not hr, check if there is a translation for the current language and return it,
 *       if not return the entity values
 * Returns an object containing the translated information
 * @param accType : AccommodationType object to retrieve translated information for.
 */
export const useGetAccommodationTypeTranslated = (
  accType?: AccommodationType,
): GetAccTypeTranslatedInfoResponse => {
  const { i18n } = useTranslation();

  const isCroatian = useIsCroatian();

  const getTranslatedAccommodationTypesData = (accType: AccommodationType) => {
    const translation = accType.translations?.find(
      (t) => t.language === getLocale(i18n.language as Language),
    );
    const enFallback = accType.translations?.find((t) => t.language === "en");
    const name = isCroatian ? accType.name : translation?.name || enFallback?.name || accType.name;
    return { translation, name };
  };

  if (accType) {
    return { ...getTranslatedAccommodationTypesData(accType), getTranslatedAccommodationTypesData };
  }

  return { name: "", getTranslatedAccommodationTypesData };
};
